import { createStyles } from '@mantine/core';
import themeVariables from '@/styles/themeVariables';

export const useNestedCommentCardStyle = createStyles(() => ({
  nestedCommentCardContainer: {
    display: 'flex',
    marginTop: 20,
  },

  descriptionContainer: {
    width: '100%',
  },

  headerContainer: {
    display: 'flex',
    alignItems: 'end',
    columnGap: 12,
  },

  headerAuthor: {
    fontSize: 15,
    fontWeight: 600,
  },

  headerDate: {
    fontSize: 13,
  },

  headerDropdownMenu: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    borderRadius: '0.5rem',
    cursor: 'pointer',
    padding: '8px 16px',
    fontSize: 14,
    '&:hover': {
      color: themeVariables.colors.blue300,
      backgroundColor: themeVariables.colors.blue000,
    },
  },

  headerDropdownContainer: {
    padding: 6,
  },

  headerPopoverMenuButton: {
    margin: '0px 4px auto auto',
  },

  editCommentinputSubmitButton: {
    color: themeVariables.fontColors.light,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    cursor: 'pointer',
    '&:hover': {
      fontWeight: 600,
    },
    '&:active': {
      fontWeight: 700,
    },
  },

  bodyContainer: {
    fontSize: 14,
    lineHeight: 1.8,
    color: themeVariables.fontColors.extraDark,
    padding: '18px 0px 24px',
  },

  footerContainer: {
    display: 'flex',
    columnGap: 6,
    fontSize: 14,
    alignItems: 'center',
  },
}));